import { useParams } from "react-router";

import type { RoutePath } from "app/constants/paths";
import type { ParamParseKey } from "react-router";

/**
 * `useParams`, typed by the registry pattern of the route that renders the
 * calling component, so param names are checked against `app/constants/paths`
 * instead of being self-asserted:
 *
 * ```ts
 * const { groupUuid } = useRouteParams(paths.groupDetails);
 * ```
 *
 * It takes exactly one pattern: `ParamParseKey` is only defined for a single
 * literal path, and given a union it keeps just the params every pattern
 * shares. A component mounted under several routes doesn't read params
 * itself — each route's element reads its own pattern and passes the values
 * down as props.
 *
 * Values are `string | undefined`, so destructure with a default or handle
 * `undefined`.
 */
export function useRouteParams<Path extends RoutePath>(pattern: Path) {
  return useParams<ParamParseKey<typeof pattern>>();
}
